// extracted by mini-css-extract-plugin
export default {"formContainer":"users_formContainer__IY+yt","cardList":"users_cardList__eR0I7","cardListitem":"users_cardListitem__W5cfs","btnSpan":"users_btnSpan__hM0AF"};